import * as SwitchPrimitives from '@radix-ui/react-switch';
import React from 'react';

import { cn } from '@/utils';

const Switch = React.forwardRef<
	React.ElementRef<typeof SwitchPrimitives.Root>,
	React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
	<SwitchPrimitives.Root
		className={cn(
			'peer group/sw inline-flex h-3 w-8 shrink-0 cursor-pointer items-center rounded-full bg-brand-gray-4 border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-2 focus-visible:ring-offset-white disabled:cursor-not-allowed',
			{
				'disabled:opacity-50': props.disabled && !props.checked,
				'opacity-100': props.disabled && props.checked
			},
			className
		)}
		{...props}
		ref={ref}
	>
		<SwitchPrimitives.Thumb
			className={cn(
				'pointer-events-none block h-4 w-4 rounded-full bg-brand-gray-3 shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:-translate-x-1',
				'data-[state=checked]:bg-brand-blue data-[state=unchecked]:bg-brand-gray-3',
				'group-hover/sw:ring-[3px] group-hover/sw:ring-brand-blue/20',
				'group-disabled/sw:bg-brand-gray-3 group-disabled/sw:ring-0'
			)}
		/>
	</SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
